import React, { useEffect, useState } from 'react';
import { Modal } from '@fluentui/react';
import { BasicHeader } from '../../actions/BasicHeader';
import { ModalContentContainer } from './ModalComponents';
import { ModalBottomButtonContainer } from './Styles';
import { PrimaryButton } from '../connectedForm/Button';
import * as Sentry from '@sentry/react';

export const ChunkErrorHandler = () => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (event) => {
      const error = event?.error || event?.reason;

      console.error('Chunk load failed:', event);
      Sentry.captureException(error);

      if (error?.name === 'ChunkLoadError') {
        setHasError(true);
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  return (
    <Modal isOpen={hasError}>
      <BasicHeader>{'Application is out of date'}</BasicHeader>
      <ModalContentContainer>
        <div style={{ maxWidth: '600px', marginBottom: '100px' }}>
          You are seeing this message because Profit4 has been updated while your browser was open. Simply click
          "Refresh" to get the latest version and continue working. Refreshing the page will load the most recent update
          and should resolve the issue. If the problem persists after refreshing, please contact support for assistance.
        </div>
      </ModalContentContainer>
      <ModalBottomButtonContainer>
        <PrimaryButton
          onClick={() => {
            window.location.reload();
          }}
          data-testid="out-of-date-refresh"
        >
          Refresh
        </PrimaryButton>
      </ModalBottomButtonContainer>
    </Modal>
  );
};
